var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.861 3 15.14 25.764H1L15.86 3zm-4.524 10.417L3.226 27.48h4.693c1.135-.154 3.947-.855 6.227-2.456.658-.461 1.214-1.124 1.676-1.89-.927-.785-2.207-2-3.142-3.237-.59-.781-1.103-1.65-1.24-2.467-.256-1.54-.266-2.78-.104-4.013zm5.004 8.465a22.406 22.406 0 0 1-2.015-2.004l2.945-.77a21.39 21.39 0 0 1-.306.975c-.108.323-.233.68-.365 1.056-.085.24-.173.49-.26.742zm2.31-2.981a16.41 16.41 0 0 1-.467 1.593c-.123.364-.25.73-.382 1.104-.175.503-.358 1.023-.542 1.583l-.017.052-.024.049c-.564 1.065-1.323 2.09-2.33 2.796a14.783 14.783 0 0 1-2.514 1.403h16.382L26.71 24c-.876-.984-2.865-3.045-4.255-3.955-.655-.43-1.51-.724-2.34-.912a11.743 11.743 0 0 0-1.465-.234zm5.576.872L15.87 5.555 14.237 8.39c-.228.396-.821 1.632-1.218 3.18-.498 1.946-.677 3.444-.31 5.648.07.42.332.956.748 1.558l4.584-1.197.09.001c.514.013 1.357.095 2.268.301.905.206 1.926.544 2.761 1.092.335.22.697.494 1.066.8z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi3);
export default __webpack_public_path__ + "static/media/API3.a7bbe90a9cb011fa5e55db1d70a72adf.svg";
export { ForwardRef as ReactComponent };